import { render, staticRenderFns } from "./PaymentMethodsButton.vue?vue&type=template&id=5692581c"
import script from "./PaymentMethodsButton.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports